import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z","key":"svg-1"}],["path",{"d":"M10 13l-1 2l1 2","key":"svg-2"}],["path",{"d":"M14 13l1 2l-1 2","key":"svg-3"}]]

const IconFileCode = createReactComponent('outline', 'file-code', 'FileCode', __iconNode);

export default IconFileCode;